/* eslint-disable */

import React, { useContext } from 'react';
import {
  AppBar,
  Box,
  IconButton,
  useMediaQuery,
  useTheme,
  Slide,
  useScrollTrigger,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { PassportAuth } from '../../contexts/AuthContext';
import { getStorage } from '../../utils/functions/localstorage';

// Slide hide on scroll down
function HideOnScroll({ children }) {
  const trigger = useScrollTrigger(); // ตรวจจับ scroll ลง
  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

export default function Navbar({
  openMobile,
  onMobileNavOpen,
  onMobileNavClose,
}) {
  const { handleSignout } = useContext(PassportAuth);
  const userName = getStorage('username');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!isMobile) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', marginBottom: { xs: '50px', md: '10px' } }}>
      <HideOnScroll>
        <AppBar
          position="fixed"
          sx={{
            height: '50px',
            background: '#f5f5f5',
            boxShadow: 'none',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              color: 'black',
              height: '100%',
              alignItems: 'center',
              px: 1,
            }}
          >
            {/* ปุ่มเปิด Sidebar */}
            <IconButton
              onClick={() => {
                if (openMobile) {
                  onMobileNavClose();
                } else {
                  onMobileNavOpen();
                }
              }}
              sx={iconButtonStyle}
            >
              <MenuIcon fontSize="small" />
            </IconButton>

            <Box flexGrow={1} />

            {/* ปุ่ม Logout */}
            <IconButton onClick={handleSignout} sx={iconButtonStyle}>
              <LogoutIcon fontSize="small" />
            </IconButton>
          </Box>
        </AppBar>
      </HideOnScroll>
    </Box>
  );
}

const iconButtonStyle = {
  p: 1.2,
  borderRadius: '12px',
  backgroundColor: '#fff',
  // boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'primary.main',
    color: '#fff',
    boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.25)',
  },
};
